import { render, staticRenderFns } from "./daily-sale-item.vue?vue&type=template&id=0161fb26"
import script from "./daily-sale-item.vue?vue&type=script&lang=js"
export * from "./daily-sale-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports